<template>
    <div :class="['sim-product-price', {
        [`sim-product-price--${type}`]: type
    }]"
    >
        <div class="sim-product-price__price">
            <template v-if="product?.hasVariations && !selectedVariation">
                {{ $t('labels.from') }}
            </template>

            {{ product?.getFormattedDiscountedPrice(selectedVariation) }}
        </div>

        <ProductDiscountBadge
            v-if="product?.isDiscounted(selectedVariation) && type !== 'no-discount-badge'"
            class="sim-product-price__discount"
            :percentage="product?.getDiscountPercents(selectedVariation)"
        />

        <div v-if="product?.isDiscounted(selectedVariation)"
             class="sim-product-price__old-price"
        >
            <template v-if="product?.hasVariations && !selectedVariation">
                {{ $t('labels.from') }}
            </template>

            {{ product.getFormattedPrice(selectedVariation) }}
        </div>
    </div>
</template>

<script lang="ts" setup>

const {
    product,
    selectedVariation,
    type = 'default',
} = defineProps<{
    product: InstanceType<typeof ProductModel> | null
    selectedVariation?: InstanceType<typeof ProductVariationModel> | null
    type?: 'default' | 'detail' | 'no-discount-badge'
}>()

</script>

<style lang="scss" scoped>

.sim-product-price {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas: "price discount"
                         "old-price old-price";

    align-items: center;
    gap: 0 0.75rem;

    min-height: 3.125rem;

    @include sim-text-normal;
}

.sim-product-price--detail {
    grid-template-columns: 1fr auto;
    grid-template-areas: "discount old-price"
                         "price price";
    justify-items: end;

    gap: 0.5rem 0.75rem;
}

.sim-product-price--no-discount-badge {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: initial;
}

.sim-product-price__price {
    grid-area: price;

    @include sim-text-normal;
    @include sim-font-bold;

    white-space: nowrap;
}

.sim-product-price--detail .sim-product-price__price {
    font-size: 1.875rem;
    line-height: 2rem;
    letter-spacing: 0.02rem;
}

.sim-product-price__discount {
    grid-area: discount;
}

.sim-product-price__old-price {
    grid-area: old-price;

    @include sim-text-small;
    text-decoration: line-through;
    color: $sim-c-basic-600;
}

.sim-product-price--detail .sim-product-price__old-price {
    @include sim-text-large;
}

</style>
